import { ApiError } from '../api/client';
import { showErrorToast, showSuccessToast } from '../components/Toast';

/**
 * Centralized error handler for API errors
 * Displays appropriate notifications and handles special cases like 401
 */
export function handleApiError(error: unknown, onUnauthorized?: () => void): void {
  if (error instanceof ApiError) {
    switch (error.statusCode) {
      case 401:
        // Show notification
        showErrorToast(error.message, 'Session Expired');
        
        // Trigger sign-out callback if provided
        if (onUnauthorized) {
          onUnauthorized();
        }
        break;
      
      case 403:
        showErrorToast(error.message, 'Permission Denied');
        break;
      
      case 400:
        showErrorToast(error.message, 'Validation Error');
        break;
      
      case 404:
        showErrorToast(error.message, 'Not Found');
        break;
      
      case 500:
      case 502:
      case 503:
      case 504:
        showErrorToast(error.message, 'Server Error');
        break;
      
      case 0:
        // Network error or timeout
        showErrorToast(error.message, 'Connection Error');
        break;
      
      default:
        showErrorToast(error.message, 'Error');
    }
  } else if (error instanceof Error) {
    // Generic error
    showErrorToast(error.message, 'Error');
  } else {
    // Unknown error
    showErrorToast('An unexpected error occurred. Please try again.', 'Error');
  }
}

/**
 * Show a success notification
 */
export function showSuccessNotification(title: string, message: string): void {
  showSuccessToast(message, title);
}

/**
 * Show an info notification
 */
export function showInfoNotification(title: string, message: string): void {
  showSuccessToast(message, title);
}
